/** Default theme settings */
export const themeSettings: App.Theme.ThemeSetting = {
  themeScheme: 'light',
  grayscale: false,
  themeColor: '#78BEFF',
  otherColor: {
    info: '#78BEFF',
    success: '#52c41a',
    warning: '#faad14',
    error: '#f5222d',
  },

}
